import { useTranslation } from 'react-i18next';
import { FilesCloudUpload } from 'modules/files';

interface NewTaskFilesTabProps {
    isSubmitting: boolean;
    cloudProgress: number | boolean;
    pendingCloudFiles: File[];
    setPendingCloudFiles: React.Dispatch<React.SetStateAction<File[]>>;
}

const NewTaskFilesTab = ({
    isSubmitting,
    cloudProgress,
    pendingCloudFiles,
    setPendingCloudFiles,
}: NewTaskFilesTabProps) => {
    const { t } = useTranslation(['Tasks', 'common']);

    return (
        <FilesCloudUpload
            disabled={isSubmitting}
            progress={cloudProgress}
            files={pendingCloudFiles}
            setFiles={setPendingCloudFiles}
            label={t('labelFiles')}
            buttonLabel={t('btnAttach')}
            uploadingLabel={t('common:buttons.uploading')}
        />
    );
};

export default NewTaskFilesTab;
